(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-before-after"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.before-after-section').forEach((section) => {
      const id = section.dataset.sectionId;
      const container = document.getElementById(`testimonials-${id}`);
      const items = container?.querySelectorAll('.before-after-section__testimonials-item');

      if (!items?.length) return;
      let currentIndex = 0;
      const scroll = (direction) => {
        currentIndex =
          direction === 'next' ? (currentIndex + 1) % items.length : (currentIndex - 1 + items.length) % items.length;
        container.scrollTo({
          left: items[currentIndex].offsetWidth * currentIndex,
          behavior: 'smooth',
        });
      };
      document.getElementById(`prev-btn-${id}`)?.addEventListener('click', () => scroll('prev'));
      document.getElementById(`next-btn-${id}`)?.addEventListener('click', () => scroll('next'));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const accordionButtons = document.querySelectorAll('.custom-faq .custom-accordion__toggle');
    accordionButtons.forEach((button) => {
      button.addEventListener('click', function () {
        const item = this.closest('.custom-faq__item');
        const allItems = document.querySelectorAll('.custom-faq .custom-faq__item');
        const isCurrentlyExpanded = item.classList.contains('expanded');

        allItems.forEach(function (otherItem) {
          otherItem.classList.remove('expanded');
        });

        if (!isCurrentlyExpanded) {
          item.classList.add('expanded');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-ingredient-show"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const toggle = document.querySelector('.ingredient-show__view-all-button');
    const expander = document.querySelector('.ingredient-show__expander');

    if (toggle && expander) {
      toggle.onclick = () => {
        expander.classList.toggle('expanded');
        toggle.classList.toggle('expanded');
      };
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-ingredients"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const toggle = document.querySelector('.view-all-button');
    const expander = document.querySelector('.expander');

    if (toggle && expander) {
      toggle.onclick = () => {
        expander.classList.toggle('expanded');
        toggle.classList.toggle('expanded');
      };
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-slider-cards"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const swiper = new Swiper('.ingredients-swiper', {
      slidesPerView: 'auto',
      centeredSlides: true,
      loop: true,
      spaceBetween: 20,
      speed: 500,
      grabCursor: true,
      navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
      breakpoints: {
        768: {
          slidesPerView: 3,
          centeredSlides: false,
          spaceBetween: 12,
        },
        1024: {
          slidesPerView: 5,
          centeredSlides: false,
          spaceBetween: 8,
        },
      },
    });

    document.querySelectorAll('.ingredient-card').forEach((card) => {
      card.addEventListener('click', (e) => {
        if (e.target.closest('.ingredient-card__close')) return;
        card.classList.toggle('ingredient-card--active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
if (!customElements.get('journal-toc')) {
  customElements.define(
    'journal-toc',
    class JournalToc extends HTMLElement {
      connectedCallback() {
        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }

        this.tocLinks = Array.from(this.querySelectorAll('.toc a[href^="#"]'));
        if (this.tocLinks.length === 0) return;

        this.headings = this.tocLinks
          .map((link) => {
            const id = (link.getAttribute('href') || '').slice(1);
            return id ? document.getElementById(id) : null;
          })
          .filter(Boolean);

        if (this.headings.length === 0) return;

        this.onIntersect = this.onIntersect.bind(this);
        this.observer = new IntersectionObserver(this.onIntersect, {
          root: null,
          rootMargin: '0px 0px -55% 0px',
          threshold: 0,
        });

        this.headings.forEach((heading) => this.observer.observe(heading));
      }

      disconnectedCallback() {
        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }
      }

      onIntersect(entries) {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

        if (visible.length === 0) return;

        const activeId = visible[0].target.id;
        this.tocLinks.forEach((link) => {
          const isActive = link.getAttribute('href') === `#${activeId}`;
          if (isActive) {
            link.setAttribute('aria-current', 'true');
          } else {
            link.removeAttribute('aria-current');
          }
        });
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();
})();
